import React from 'react'

const patientPortalRoutes = [
    {
        key: 'patient.dashboard',
        path: '/dashboard',
        component: React.lazy(() => import('views/patient-portal/Dashboard')),
        authority: [],
    },
]

export default patientPortalRoutes
